var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"watermark absolute w-full h-full top-0 left-0 bg-repeat",style:({ backgroundImage: _vm.svgWatermark1+_vm.watermarkContent+_vm.svgWatermark2})})])
}
var staticRenderFns = []

export { render, staticRenderFns }